import { toBundleCartLineItem } from "./bundle-cart-line-item.js";
import { toContactLensesCartLineItem } from "./contact-lenses-line-item.js";
import { toRegularCartLineItem } from "./regular-line-item.js";
const toVisualLineItem = (serverLineItem, intl, settings, apiUrl) => {
  if (serverLineItem.__typename === "LineItemBundle") {
    return toBundleCartLineItem(serverLineItem, intl, settings, apiUrl);
  }
  if (serverLineItem.__typename === "LineItemContactLenses") {
    return toContactLensesCartLineItem(serverLineItem, intl, settings, apiUrl);
  }
  if (serverLineItem.__typename === "LineItemRegular") {
    return toRegularCartLineItem(serverLineItem, intl, settings);
  }
};
export {
  toVisualLineItem
};
//# sourceMappingURL=cart-line-item.js.map
